import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarType } from '@alf-nx-workspace/shared/interfaces';
import { TranslationService } from '@alfresco/adf-core';
import { EbenGenericError, EbenProcessInstance, EbenTaskDetail, ProcessGenericError, ProcessInstanceCancelError } from '@alf-nx-workspace/eben/interfaces';
import { ErrorMessage } from './error.service';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { TaskCompletedSnackbar } from './snackbar-task-complete-success/task-completed-snackbar.component';
import { ComponentType } from '@angular/cdk/portal';
import { ProcessInstanceCancelSuccess } from './snackbar-process-instance-cancel-success/process-instance-cancel-success.component';

@Injectable({
  providedIn: "root"
})
export class SnackbarService {

  private snackbar = inject(MatSnackBar)
  private translationService = inject(TranslationService);

  private snackbarQueue: { error?: ProcessGenericError, task?: EbenTaskDetail, processInstance?: EbenProcessInstance, component: ComponentType<unknown>, duration: number}[] = [];
  private isShowingSnackbar = false;

  public onTaskCompleteSuccess(task?: EbenTaskDetail) {
    this.snackbarQueue.push({ task, component: TaskCompletedSnackbar, duration: 3000 });
    if (!this.isShowingSnackbar) {
      this.showNextSnackbar();
    }
  }

  public onProcessInstanceCancelSuccess() {
    this.snackbarQueue.push({ component: ProcessInstanceCancelSuccess, duration: 3000 });
    if (!this.isShowingSnackbar) {
      this.showNextSnackbar();
    }
  }

  private showNextSnackbar() {
    if (this.snackbarQueue.length === 0) {
      this.isShowingSnackbar = false;
      return;
    }
    this.isShowingSnackbar = true;
    const next = this.snackbarQueue.shift()!;
    const ref = this.snackbar.openFromComponent(next.component, {
      data: {
        task: next.task,
        error: next.error,
        duration: next.duration
      },
      duration: next.duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'snackbar-success',
    });

    ref.afterDismissed().subscribe(() => {
      this.showNextSnackbar();
    });
  }

  public info(message: string) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      data: {
        type: SnackbarType.success,
        message,
      },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'snackbar-success',
    });
  }

  public error(error: unknown, withSendReport = false) {
    const snackbar = this.snackbar.openFromComponent(SnackbarComponent, {
      data: {
        type: SnackbarType.error,
        message: ErrorMessage.createMessageFromError(error),
        action: withSendReport ? 'SNACKBAR.SERVER_ERROR_SUPPORT' : null
      },
      duration: 0,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'snackbar-error',
    });
    snackbar.afterDismissed().subscribe((result) => {
      if(result.dismissedByAction) {

        const newline = "%0D%0A";
        const mailTo = "boku-it@boku.ac.at";
        const subject = "BOKUflow";

        const body: string[] = [
          "Liebe Hotline,",
          "ich habe folgende die Meldung in BOKUflow erhalten:",
          "",
          '"' + this.translationService.instant(ErrorMessage.createMessageFromError(error)) + '"',
          "",
          "---",
          'Timestamp: ' + (error as EbenGenericError).timestamp.toISOString(),
          ErrorMessage.createSupportRequestInformationBlockFromError(error)
        ]

        const mail = `mailto:${mailTo}?subject=${subject}&body=${body.join(newline)}`;
        window.open(mail, '_blank');
      }
    })
  }
}
